const blue = "#3d9cfc";
const green = "#12bfaa";
const yellow = "#dc851f";
const red = "#f1364c";
const black = "#3f4354";

export const OutStateColor = {
  0: black, // 未出库
  1: green, // 出库完成
  2: yellow, // 部分出库
};
export const InStateColor = {
  0: black, // 未入库
  1: green, // 已入库
  2: yellow, // 部分入库
};

export const ReceiveColor = {
  0: yellow, // 未接收
  1: green, // 已接收
};

export const PuerchaseReceiveColor = {
  0: yellow, // 未接收
  1: green, // 已发送
  2: blue, // 已接受
  3: red, // 已取消
};

export const ProdStateColor = {
  0: black, // 未开始
  1: yellow, // 生产中
  2: green, // 生产完成
};

// 字典值
export const DictionaryKey = {
  CustLevel: "KHLevel_Key",
  CustSource: "KHFormSource_Key",
  FollowState: "KHFollowUpState_Key",
  FollowWay: "KHFollowupMethod_key",
  OperateType: "OperateType_Key",
  ContractType: "ContractType_key",
  ReceiptType: "ReceiptType_Key",
};

// 是否首要联系人
export const IsChief = {
  // "-1": "未知",
  0: "否",
  1: "是",
};

// 性别
export const LinkSex = {
  // 0: "未知",
  1: "男",
  2: "女",
};

// 报备状态
export const ReportState = {
  0: "未报备",
  1: "已报备",
};

// 审核状态
export const AuditStateVal = {
  inReview: 0,
  passed: 1,
  refuse: 2,
  withdraw: 3,
};
// 审核状态
export const AuditState = {
  0: "审核中",
  1: "已通过",
  2: "未通过",
  3: "已撤销",
};
